<template>
    <div class="c-dna-view">
        <div v-if="client.measurement_result == null" class="no-data">
            {{$t('dnaview.error')}}
        </div>
        <div v-else>
            <div class="dna">
                <img src="/img/avatar.svg" class="avatar" />
                <img :src="'img/dna-pillow'+ result.PillowAdvice +'.svg'" class="dna-pillow" v-if="result.PillowAdvice > 0">
                <DNACurve :curveWidth="curveWidth" :curveData="curveData" />
                <SleepDNA :result="result" />
            </div>
            <div class="c-dna-view--row">
                <div class="checkboxes left">
                    <div class="checkbox" :class="{checked : result.BasePreference && result.BasePreference.indexOf('P4') > -1}"></div>
                    <div class="label">
                        P4 SY2/4
                    </div>
                    <div class="checkbox"  :class="{checked : result.BasePreference && result.BasePreference.indexOf('BS4') > -1}"></div>
                    <div class="label">
                        BS4 SY2/4
                    </div>
                </div>
                <div class="checkboxes right">
                    <div class="checkbox " :class="{checked : result.ZoneAdapt == 'true'}"></div> <!-- moet string zijn -->
                    <div>
                        Zone adapt
                    </div>
                </div>
            </div>
            <div class="c-dna-view--row">
                <div class="dna-table">
                    <DNATable :result="result" />
                    <div class="dnatable-label">
                        {{$t('dnaview.bedbase')}}
                    </div>
                </div>
                <div class="mattress-advice">
                    <MattressAdvice :result="result" :clientInfo="clientInfo"/>
                    <div class="mattress-label">
                        {{$t('dnaview.mattress')}}
                    </div>
                </div>
            </div>
            <div class="c-dna-view--row">
                <div class="pillow-advice">
                    <div class="label">
                        {{$t('dnaview.pillow')}}
                    </div>
                    <div class="pillow" v-for="i in 3" :key="i">
                        <div class="checkbox" :class="{checked: i == result.PillowAdvice}"></div>
                        <img :src="'img/dna-pillow'+ i +'.svg'">
                    </div>
                </div>
            </div>

            <div class="qr">
                <img src="/img/phone.svg" class="phone" />
                <QRImage :code="client.ergosleep_id" />
            </div>

        </div>
    </div>
</template>

<script>
import SleepDNA from "@/components/dna/SleepDNA.vue";
import DNACurve from "@/components/dna/DNACurve.vue";
import QRImage from "@/components/dna/QRImage.vue";
import DNATable from "@/components/dna/DNATable.vue";
import MattressAdvice from "@/components/dna/MattressAdvice.vue";

export default {
    name : "DNAView",
    components: {
        DNATable,
        DNACurve,
        SleepDNA,
        QRImage,
        MattressAdvice
    },
    props: {
        client: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            curveWidth: 0
        };
    },

    mounted() {
        window.addEventListener("resize", this.onResize);
        this.onResize();
    },
    unmounted() {
        window.removeEventListener("resize", this.onResize);
    },

    methods: {
        onResize() {
            const el = document.getElementsByClassName("dna")[0];
            if (el) {
                this.curveWidth = parseInt(el.clientWidth);
            }
        }
    },

    computed: {
        result() {
            return this.client.measurement_result;
        },

        clientInfo() {
            return this.client.additional_info;
        },

        curveData() {
            let curve = [];
            for (let i = 1; i <= 13; i++) {
                const val = this.client.measurement_result["SensorL" + i];
                if (val !== undefined) {
                    curve.push(val);
                }
            }

            return curve;
        }
    }
};
</script>

<style lang="scss" scoped>
.c-dna-view {
    .no-data {
        margin-bottom : 1rem;
    }

    .dna {
        width : 65%;
        margin : auto;
        position: relative;

        .avatar {
            width: 98%;
            margin: auto;
            display: block;
        }

        .dna-pillow {
            width : 16%;
            position: absolute;
            top: 54%;
        }

        .c-sleep-dna {
            margin-bottom: 2rem;
            margin-top: -.5rem;
        }
    }

    &--row {
        display: flex;
        justify-content: space-between;

        .pillow-advice {
            margin-top : 1rem;
            margin-left : .8rem;
            display: flex;
            align-items: center;

            .pillow {
                display: flex;
                align-items: center;
                margin-left : 2rem;
            }

            .label {
                letter-spacing: .2rem;
                text-transform: uppercase;
            }

            img {
                margin-bottom : .65rem;
                width : 6rem;

            }
        }

        .dna-table {
            padding : 0 1%;
            width : 50%;
            position: relative;
        }

        .mattress-advice {
            padding : 0 1%;
            width : 50%;
            position: relative;
        }
    }

    .qr {
        position: fixed;
        right: 7rem;
        bottom: 1rem;
        display : flex;

        .phone {
            height : 7rem;
            display: inline-block;
            margin-right : 2rem;
        }
    }

    .checkboxes {
        letter-spacing: .2rem;
        color : #6F6F6E;
        display:flex;
        align-items: center;
        margin-bottom: .25rem;

        &.left {
            justify-content: flex-start;
            text-align: left;
            margin-left : 3rem;
        }

        &.right {
            justify-content: flex-end;
            text-align: right;
        }

        .label {
            margin-right: 1.5rem;
        }
    }

    .checkbox {
        border : solid .1rem #3C3C3B;
        border-radius : 50%;
        width : 1rem;
        height : 1rem;
        margin : .5rem;

        &.checked {
            background : #3C3C3B;
        }
    }

    .dnatable-label {
        transform: rotate(-90deg);
        position: absolute;
        left: -0.7rem;
        bottom: -0.9rem;
        transform-origin: 0% 0%;
        text-transform: capitalize;
        width: 12rem;
        text-align: left;
        font-size: .9em;
        letter-spacing: .1rem;
    }

    .mattress-label {
        transform: rotate(-90deg);
        position: absolute;
        right: -0.7rem;
        bottom: 12rem;
        transform-origin: 100% 100%;
        text-transform: capitalize;
        width: 12rem;
        text-align: left;
        font-size : .9em;
        letter-spacing :.1rem;
    }

    .btn-print {
        @extend .reset-btn;
        background-image: url('/img/icon-print.svg');
        background-position:center;
        background-size: 65%;
        background-repeat: no-repeat;
        border : solid 2px black;
        width: 4rem;
        height: 4rem;
        position: absolute;
        top: 1rem;
        right: 1.8rem;
        z-index: 5;
        border-radius:50%;

        transition : background-color 250ms;
        &:active {
            background-color : #ddd;
        }
    }
}

</style>